// eslint-disable-next-line import/no-cycle
import GDPR from './gdpr';
import views from './views';

class MoveBack {
  constructor(options) {
    this.moveBackBtn = options.moveBackBtn;
    this.prevPage = options.prevPage;
  }

  render() {
    const { moveBackBtn } = this;
    const { prevPage } = this;

    moveBackBtn.one('tap', (e) => {
      e.preventDefault();

      if (prevPage === 'gdpr') {
        new GDPR({ currentPage: views.common.gdpr }).render();
      } else {
        Pollfish.helper.initSingleSurvey();
      }
    });
  }
}

export default MoveBack;
